import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import utc from 'dayjs/plugin/utc'
import { isNull, isString, reduce, split, toUpper } from 'lodash'

dayjs.extend(utc)
dayjs.extend(localizedFormat)

export const currency = (x: number | string) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(isString(x) ? parseFloat(x) : x)
// this works by coercing input to number by marking it positive, which results in NaN for non-numeric things (except null)
export const isNumeric = (x: number | string | null) => !isNull(x) && +x === +x
export const initials = (str?: string | null, separator?: string) =>
  reduce(
    split(str, separator),
    (acc, word) => (!isNumeric(word) ? `${acc}${toUpper(word.charAt(0))}` : `${acc}${word}`),
    ''
  )
// Sugar returns UTC in MySQL datetime format ("YYYY-MM-DD HH:MM:SS") with no "T" and no offset.
// dayjs() parses that as LOCAL time, which is a six-hour error in America/Denver. Always go through utc().
//
// No customParseFormat needed: dayjs's own REGEX_PARSE accepts `[Tt\s]` as the date/time separator, so
// this format is parsed by dayjs itself and never handed to `new Date(string)` — which is the only path
// where browser-to-browser parsing differences would apply.
//
// The isValid() guard matters because `.format()` on an unparseable value returns the literal string
// "Invalid Date", which would otherwise render as "Invalid Date by Jane Doe" in a Confirmed row.
export const sugarDateTime = (value?: string | null): string | null => {
  const parsed = value ? dayjs.utc(value) : null

  return parsed?.isValid() ? parsed.local().format('lll') : null
}
